import React from 'react';
import PropTypes from 'prop-types';

/**
 * Input component for form fields
 */
const Input = ({ 
  type = 'text',
  value,
  onChange,
  placeholder = '',
  className = '',
  size = 'md',
  variant = 'default',
  disabled = false,
  error = false,
  ...props 
}) => {
  const baseClasses = "w-full border rounded-lg transition-colors focus:ring-2 focus:ring-purple-500 focus:border-transparent";
  
  const sizeClasses = {
    sm: "px-3 py-1.5 text-sm",
    md: "px-3 py-2 text-sm",
    lg: "px-4 py-3 text-base"
  };

  const variantClasses = {
    default: error 
      ? "border-red-300 bg-red-50 text-red-900 placeholder-red-400" 
      : "border-gray-300 bg-white text-gray-900 placeholder-gray-400",
    outline: error
      ? "border-red-500 bg-white text-red-900 placeholder-red-400"
      : "border-gray-400 bg-white text-gray-900 placeholder-gray-500"
  };

  const disabledClasses = disabled ? "bg-gray-100 text-gray-500 cursor-not-allowed" : "";

  return (
    <input
      type={type}
      value={value}
      onChange={(e) => onChange?.(e.target.value)}
      placeholder={placeholder}
      disabled={disabled}
      className={`${baseClasses} ${sizeClasses[size]} ${variantClasses[variant]} ${disabledClasses} ${className}`}
      {...props}
    />
  );
};

Input.propTypes = {
  type: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  variant: PropTypes.oneOf(['default', 'outline']),
  disabled: PropTypes.bool,
  error: PropTypes.bool
};

export default Input;
